/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Stages_TitleInputs */

const en_directory_ai_tools_stages_title = /** @type {(inputs: Directory_Ai_Tools_Stages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four stages to choose from`)
};

const zh_directory_ai_tools_stages_title = /** @type {(inputs: Directory_Ai_Tools_Stages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四种舞台可选`)
};

/**
* | output |
* | --- |
* | "Four stages to choose from" |
*
* @param {Directory_Ai_Tools_Stages_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_stages_title = /** @type {((inputs?: Directory_Ai_Tools_Stages_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Stages_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_stages_title(inputs)
	return zh_directory_ai_tools_stages_title(inputs)
});
export { directory_ai_tools_stages_title as "directory.ai_tools.stages_title" }